"use client";

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { spacing24, spacing48, borderColorTertiary, backgroundColorHover, accentColorLink } from "@churchofjesuschrist/eden-style-constants";
import { Text3 } from "@churchofjesuschrist/eden-text";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const OuterWrapper = styled(Text3).withConfig({
  componentId: "sc-58af31-0"
})(["border-block-end:1px solid ", ";transition:padding-block-end 80ms ease-out;> .innerWrapper{padding-inline:", ";}&:not([open]):hover,summary:hover{text-decoration:underline 1px solid ", ";background:", ";}&[open]{padding-block-end:", ";transition:padding-block-end 80ms ease-in;}"], borderColorTertiary, spacing24, accentColorLink, backgroundColorHover, spacing48);

/**
 * A `Drawer` enables users to expand and collapse sections of content, emphasizing important details of a section and revealing more information upon a tap or a click. Because of this, significant information is displayed first (`Summary`), while the additional details remain easily accessible and readily available for comparison.
 */
const Drawer = ({
  children,
  ...props
}) => {
  const childNodes = React.Children.toArray(children);
  const summary = childNodes.shift();
  return /*#__PURE__*/_jsxs(OuterWrapper, {
    as: "details",
    ...props,
    children: [summary, /*#__PURE__*/_jsx("div", {
      className: "innerWrapper",
      children: childNodes
    })]
  });
};
Drawer.displayName = "Drawer";
Drawer.propTypes = {
  /** Contents rendered inside the details. First child needs to be an `eden-drawer` `<Summary>` element. */
  children: PropTypes.node.isRequired,
  /** Whether details is open */
  open: PropTypes.bool,
  /** Handler called after a toggle occurs. Use `event.target.open` to get the current `open` state of the `Drawer`.  */
  onToggle: PropTypes.func
};
export default Drawer;